import { render, staticRenderFns } from "./WorldObjectIcon.vue?vue&type=template&id=3a16c61e&scoped=true&"
import script from "./WorldObjectIcon.vue?vue&type=script&lang=js&"
export * from "./WorldObjectIcon.vue?vue&type=script&lang=js&"
import style0 from "./WorldObjectIcon.vue?vue&type=style&index=0&id=3a16c61e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a16c61e",
  null
  
)

export default component.exports